const BillMixUpdateCannedResponse = {
    "ALPHA": {
        "echo": [
            {
                "blue": [
                    {
                        "workstations": [
                            {
                                "invalid": false,
                                "id": "SVE21893",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41472",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41812",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            },
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM99",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            }
                        ],
                        "errorType": ""
                    }
                ],
                "green": [
                    {
                        "workstations": [
                            {
                                "invalid": false,
                                "id": "SVE21893",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41472",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41812",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM97",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM97",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM99",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            }
                        ],
                        "errorType": ""
                    }
                ]
            }
        ],
        "tango": [
            {
                "blue": [
                    {
                        "workstations": [
                            {
                                "invalid": false,
                                "id": "SVE41812",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL",
                                "processing_center": "ALPHA",
                                "deployment": "BLUE"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM97",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL",
                                "processing_center": "ALPHA",
                                "deployment": "GREEN"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM98",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL",
                                "processing_center": "ALPHA",
                                "deployment": "GREEN"
                            },
                            {
                                "invalid": false,
                                "id": "T4VATM99",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL",
                                "processing_center": "ALPHA",
                                "deployment": "GREEN"
                            }
                        ],
                        "errorType": ""
                    }
                ]
            }
        ]
    },
    "OMEGA": {
        "echo": [
            {
                "green": [
                    {
                        "workstations": [
                            {
                                "invalid": false,
                                "id": "SVE21893",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41472",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": false,
                                "id": "SVE41812",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            },
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            }
                        ],
                        "errorType": ""
                    }
                ]
            }
        ]
    }
}
export default BillMixUpdateCannedResponse;